/*
 * Ansicht-Umschalter auf Collection-Seiten (mobil): 2 Produkte nebeneinander oder 1 pro Zeile.
 * Buttons: snippets/collection-top-bar.liquid. Raster per CSS-Variable in sections/main-collection.liquid, das
 * Mini-Script dort setzt die gespeicherte Wahl schon vor dem Rendern (<html data-ll-grid>).
 *
 * Hier nur: Klick -> <html data-ll-grid> + localStorage, und bei 1 Produkt pro Zeile das sizes-Attribut der
 * Kartenbilder auf volle Breite setzen (sonst laedt der Browser die halb so grossen Bilder fuer 2 Spalten und sie
 * wirken unscharf). Bei 2 Spalten bleibt alles wie geliefert - kein Mehraufwand fuer die Standard-Ansicht.
 */
const root = document.documentElement;
const HALF = "(max-width: 699px) calc(100vw / 2 - 40px)";
const FULL = "(max-width: 699px) calc(100vw - 40px)";

const updateImages = () => {
  const one = root.getAttribute("data-ll-grid") === "1";
  const [from, to] = one ? [HALF, FULL] : [FULL, HALF];
  document.querySelectorAll(`product-list img[sizes^="${from}"]`).forEach((image) => {
    image.sizes = image.sizes.replace(from, to);
  });
};

const syncButtons = () => {
  const current = root.getAttribute("data-ll-grid");
  document.querySelectorAll("[data-ll-grid-set]").forEach((button) => {
    const value = current || button.closest(".ll-grid-toggle")?.dataset.default;
    button.setAttribute("aria-pressed", String(button.dataset.llGridSet === value));
  });
};

document.addEventListener("click", (event) => {
  const button = event.target.closest("[data-ll-grid-set]");
  if (!button) {
    return;
  }
  const value = button.dataset.llGridSet;
  root.setAttribute("data-ll-grid", value);
  try {
    localStorage.setItem("ll-grid", value);
  } catch {
    // Speicher gesperrt (privates Fenster): gilt nur fuer diese Seite
  }
  syncButtons();
  updateImages();
});

syncButtons();
updateImages();

// Nachgeladene Produkte (Filter, Sortierung, Endlos-Scroll) und neu gerenderte Buttons nachziehen
let queued = false;
new MutationObserver(() => {
  if (!queued) {
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      syncButtons();
      if (root.getAttribute("data-ll-grid") === "1") {
        updateImages();
      }
    });
  }
}).observe(document.querySelector(".collection") || document.body, { childList: true, subtree: true });
